import { useContext } from "react";
import { Steps } from "antd";

import { SpecSettingContext } from "../../pages/SpecSetting";

const { Step } = Steps;

const SettingSteps = () => {
  const { currentStep, steps, handleStepChange } = useContext(SpecSettingContext);

  return (
    <Steps
      current={currentStep}
      onChange={(step) => handleStepChange(step)}
    >
      {steps.map((step, index) => (
        <Step key={index} title={step.title} description={step.description} />
      ))}
    </Steps>
  );
};

export default SettingSteps;
